import {useEffect} from 'react';
import {SkeletonTheme} from 'react-loading-skeleton';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import './App.css';
import {EdgesProvider} from './features/edges/context/EdgesContext';
import {SidebarProvider} from './shared/context/SidebarContext';
import {ThemeProvider} from './shared/context/ThemeContext';
import Configuration from './features/configuration';
import DocumentationPage from './features/configuration/pages/DocumentationPage';
import SettingsPage from './features/configuration/pages/SettingsPage';
import Edges from './features/edges';
import {AuthContextProvider} from './shared/services/firebase';
import MeterReport from './features/meterReport';
import Navigation from './shared/ui/Navigation';
import Sidebar from './shared/ui/Navigation/Sidebar';
import Statistics from './features/statistics';
import {AuthenticatedRoute} from './features/auth';
import {Signup} from './features/auth';
import './shared/ui/Navigation/navbar.css';
import {TenantsProvider} from "./features/tenants/context/TenantsContext";
import Tenants from "./features/tenants";
import Changelog, {ChangelogDetailPage} from "./features/changelog";
import {ChangelogProvider} from "./features/changelog/context/ChangelogContext";

(function initTheme() {
  try {
    const saved = localStorage.getItem('theme');
    document.documentElement.dataset.theme = saved || (globalThis.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
    document.documentElement.classList.add('no-theme-transition');
  } catch (e) {
    console.error('Failed to initialize theme:', e);
  }
})();

function App() {
  useEffect(() => {
    // allow transitions after first paint with correct theme
    document.documentElement.classList.remove('no-theme-transition');
  }, []);
  return (
    <ThemeProvider>
      {/* SkeletonTheme picks up CSS variable changes for dark/light automatically */}
      <SkeletonTheme baseColor="var(--skeleton-base)" highlightColor="var(--skeleton-highlight)">
        <div className="App">
          <AuthContextProvider>
            <TenantsProvider>
              <EdgesProvider>
                <ChangelogProvider>
                <SidebarProvider>
                  <Router>
                    <div className="d-flex app-shell">
                      <Sidebar/>
                      <div className="flex-grow-1 d-flex flex-column app-main-pane">
                        <Navigation/>
                        <div className="main-content">
                          <Switch>
                            {/*<AuthenticatedRoute exact path="/" component={ Dashboard } />*/}
                            <AuthenticatedRoute exact path="/" component={Edges}/>
                            {/*<AuthenticatedRoute exact path="/edges" component={ EdgesOverview } />*/}
                            <Route exact path="/signup" component={Signup}/>
                            <AuthenticatedRoute exact path="/edges/:eid/statistics" component={Statistics}/>
                            <AuthenticatedRoute exact path="/edges/:eid/configuration" component={Configuration}/>
                            <AuthenticatedRoute exact path="/edges/:eid/documentation" component={DocumentationPage}/>
                            <AuthenticatedRoute exact path="/edges/:eid/settings" component={SettingsPage}/>
                            <AuthenticatedRoute exact path="/edges/:eid/meterreport" component={MeterReport}/>
                            <AuthenticatedRoute exact path="/tenants" component={Tenants}/>
                            <AuthenticatedRoute exact path="/changelog" component={Changelog}/>
                            <AuthenticatedRoute exact path="/changelog/:id" component={ChangelogDetailPage}/>
                          </Switch>
                        </div>
                      </div>
                    </div>
                  </Router>
                </SidebarProvider>
                </ChangelogProvider>
              </EdgesProvider>
            </TenantsProvider>
          </AuthContextProvider>
        </div>
      </SkeletonTheme>
    </ThemeProvider>
  );
}

export default App;
